import { render, staticRenderFns } from "./MinsyuntuInput.vue?vue&type=template&id=85d7b278&scoped=true"
import script from "./MinsyuntuInput.vue?vue&type=script&lang=js"
export * from "./MinsyuntuInput.vue?vue&type=script&lang=js"
import style0 from "./MinsyuntuInput.vue?vue&type=style&index=0&id=85d7b278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d7b278",
  null
  
)

export default component.exports